export const globalLoadingAction = loading => ({
  type: "IS_LOADING",
  payload: loading
});

export const updateMessageAction = message => ({
  type: "UPDATE_MESSAGE",
  payload: message
});
